export class Calendar {
    static moduleName = 'calendar';
    static moduleEntityName = 'calendarEntity';
    static listTitle = 'Календарь';
    static createTitle = 'Добавление записи в календарь';
    static apiPrefix = 'calendar';
}
